/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Color_VariantsInputs */

const en_svchip_color_variants = /** @type {(inputs: Svchip_Color_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color variants`)
};

const ar_svchip_color_variants = /** @type {(inputs: Svchip_Color_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متغيرات لونية`)
};

const bn_svchip_color_variants = /** @type {(inputs: Svchip_Color_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রঙের ধরন`)
};

const de_svchip_color_variants = /** @type {(inputs: Svchip_Color_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbvarianten`)
};

const es_svchip_color_variants = /** @type {(inputs: Svchip_Color_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variantes de color`)
};

const fr_svchip_color_variants = /** @type {(inputs: Svchip_Color_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variantes de couleur`)
};

const pt_svchip_color_variants = /** @type {(inputs: Svchip_Color_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variantes de cor`)
};

const zh_svchip_color_variants = /** @type {(inputs: Svchip_Color_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配色变体`)
};

const tr_svchip_color_variants = /** @type {(inputs: Svchip_Color_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renk varyantları`)
};

const ru_svchip_color_variants = /** @type {(inputs: Svchip_Color_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цветовые варианты`)
};

const pl_svchip_color_variants = /** @type {(inputs: Svchip_Color_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warianty kolorów`)
};

/**
* | output |
* | --- |
* | "Color variants" |
*
* @param {Svchip_Color_VariantsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_color_variants = /** @type {((inputs?: Svchip_Color_VariantsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Color_VariantsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_color_variants(inputs)
	if (locale === "bn") return bn_svchip_color_variants(inputs)
	if (locale === "de") return de_svchip_color_variants(inputs)
	if (locale === "es") return es_svchip_color_variants(inputs)
	if (locale === "fr") return fr_svchip_color_variants(inputs)
	if (locale === "pt") return pt_svchip_color_variants(inputs)
	if (locale === "zh") return zh_svchip_color_variants(inputs)
	if (locale === "tr") return tr_svchip_color_variants(inputs)
	if (locale === "ru") return ru_svchip_color_variants(inputs)
	if (locale === "pl") return pl_svchip_color_variants(inputs)
	return en_svchip_color_variants(inputs)
});